import { render, staticRenderFns } from "./bjManage.vue?vue&type=template&id=f9a8a31a&scoped=true&"
import script from "./bjManage.vue?vue&type=script&lang=js&"
export * from "./bjManage.vue?vue&type=script&lang=js&"
import style0 from "./bjManage.vue?vue&type=style&index=0&id=f9a8a31a&lang=less&scoped=true&"
import style1 from "./bjManage.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9a8a31a",
  null
  
)

component.options.__file = "bjManage.vue"
export default component.exports